export default __webpack_public_path__ + "static/media/avatarPlaceholder.3a5b0cce.png";